module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "id": "mainwrap"
    }
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), (!_vm.isInApp) ? _vm._m(0) : _vm._e(), _vm._v(" "), (_vm.articleBody.title) ? _c('headerTitle', {
    attrs: {
      "title": _vm.articleBody.title,
      "time": _vm.articleBody.time,
      "writer": _vm.articleBody.writer,
      "afhao": _vm.articleBody.afh_info
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleBody.body) ? _c('articleCon', {
    attrs: {
      "bodydata": _vm.articleBody.body,
      "afhao": _vm.articleBody.afh_info
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleBody.infos) ? _c('infos', {
    attrs: {
      "infos": _vm.articleBody.infos
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadItem) ? _c('relatedNews', {
    attrs: {
      "articleId": _vm.articleBody.article_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadItem) ? _c('comments', {
    attrs: {
      "articleId": _vm.articleBody.article_id,
      "time": 3000
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bodyLoad && _vm.loadItem && !_vm.isInApp) ? _vm._m(1) : _vm._e(), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadHeader', {
    attrs: {
      "id": "headwrap"
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadFooter', {
    attrs: {
      "text": "Download All Football for more comments"
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_vm._v("Links："), _c('a', {
    attrs: {
      "href": "http://footballlive.cc/"
    }
  }, [_vm._v("Football Live | Football Results | Player Scored")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c650d308","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppNews.vue
// module id = 754
// module chunks = 1